import React from 'react'
import { FormHelperText, FormControl, OutlinedInput } from '@material-ui/core'

// a wrapper function to directly pass the input value into the callback
const onChange = (callback) => (event) => callback(event.target.value)

/* A text input with validation.
The validationError prop will be displayed under the input field,
if it's supplied */
const ValidatedTextInput = (props) => (
  <FormControl className={props.classes.formControl}>
    <OutlinedInput
      className={props.classes.textField}
      value={props.value}
      onChange={onChange(props.onChange)}
      placeholder={props.placeholder}
      type={props.type || 'text'}
      autoComplete={props.autoComplete}
      multiline={props.multiline}
      inputProps={props.inputProps}
      labelWidth={0}
    />
    {
      props.validationError
        ? (<FormHelperText className={props.classes.errorHelperText}>
            {props.validationError}
          </FormHelperText>)
        : undefined
    }
  </FormControl>
)

export default ValidatedTextInput
